module.exports = __webpack_public_path__ + "49e0af642e0417162c6c33b9a88462df.svg";